<template>
  <div class="row mt-4 box-users">
    <div class="col-md-6 border-right mb-3">
      <h5>Usuarios de la empresa</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="search"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
          data-cy="search-user"
        />
      </div>
    </div>
    <div class="col-md-6 border-right mb-3">
      <h5>Usuarios en el grupo</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="searchUsers"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
          data-cy="search-user-group"
        />
      </div>
    </div>
    <div class="col-md-6 border-right">
      <vs-list class="box-users" data-cy="company-users">
        <div v-for="user in filteredUsers" :key="user.id" data-cy="user">
          <vs-list-item
              :class="{ exists: isUserInGroup(user) }"
              :title="user.nombre"
              :subtitle="user.correo"
          >
            <vs-button
              color="warning"
              v-if="!isUserInGroup(user)"
              size="small"
              type="border"
              @click="addUser(user)"
              data-cy="add-user"
            >
              Agregar
            </vs-button>
          </vs-list-item>
        </div>
      </vs-list>
    </div>
    <div class="col-md-6">
      <vs-list class="box-users" data-cy="group-users">
        <div
          v-for="user in filteredUsersOnGroup"
          :key="user.id"
          data-cy="user"
        >
          <vs-list-item
              :title="user.nombre"
              :subtitle="user.correo"
          >
            <vs-chip
              color="warning"
               v-if="user.esLider === 'Y'"
            >
              <vs-avatar icon="flag" />
              lider
            </vs-chip>
            <vs-button
              color="danger"
              size="small"
              type="border"
              icon="highlight_off"
              @click="removeUser(user)"
              data-cy="remove-user"
            >
            </vs-button>
          </vs-list-item>
        </div>
      </vs-list>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [],
  props: {
    group: {
      type: Object,
      required: true
    },
    usersGeneral: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: '',
      searchUsers: '',
      usersGroup: {
        ...this.group
      },
      usersOnGroup: this.usersByGroup
    };
  },
  watch: {
    group(newValue) {
      this.usersGroup = { ...newValue };
    },
    usersByGroup(newValue) {
      this.usersOnGroup = newValue;
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersByGroup',
      'usersCompanyAssign'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    filteredUsers() {
      if (this.search !== '') {
        return this.usersGeneral
          .filter((user) => user.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
      }
      return this.usersGeneral;
    },
    filteredUsersOnGroup() {
      if (this.searchUsers !== '') {
        return this.usersOnGroup
          .filter((user) => user.nombre.toLowerCase().indexOf(this.searchUsers.toLowerCase()) > -1);
      }
      return this.usersOnGroup;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'getUsersGroup',
      'addUserToGroupV2',
      'removeUserToGroup'
    ]),
    isUserInGroup(user) {
      return (this.usersByGroup || []).find((userGroup) => userGroup.id === user.id);
    },
    removeUser(user) {
      this.removeUserToGroup({
        empresaId: this.company.id,
        grupoId: this.usersGroup.id,
        usuarioId: user.id,
        user
      });
    },
    async addUser(user) {
      await this.addUserToGroupV2({
        companyId: this.company.id,
        groupId: this.group.id,
        userId: user.id
      });
      this.usersOnGroup.push(user);
    }
  },
  mounted() {
    this.usersOnGroup = this.usersByGroup;
  }
};
</script>
<style scoped>

.box-users {
  height: 500px;
  overflow-y: auto;
}

.con-vs-popup .vs-popup {
  width: 70% !important;
}

.exists {
  color: #671e85;
  background: #671e852b;
  border-radius: 4px;
  margin-top: 2px;
}
</style>
